(function ($) {
  "use strict";
  var key;
  var sectionId;

  function initGallery() {
    var galeria = document.getElementById('galeria-' + sectionId);

    if (galeria) {
      galeria.querySelectorAll('.ficha_image_small img').forEach(function (thumb) {
        thumb.style.cursor = 'pointer';
        thumb.addEventListener('click', function () {
          var mainImg = document.getElementById('ficha-main-image-' + sectionId);
          if (mainImg && thumb.dataset.srcFull) {
            mainImg.src = thumb.dataset.srcFull;
          }
          galeria.querySelectorAll('.ficha_image_small').forEach(function (el) {
            el.classList.remove('current');
          });
          thumb.closest('.ficha_image_small').classList.add('current');
        });
      });
    }
  }

  function formatMoney(cents) {
    if (cents == null) return '';
    return '$ ' + (cents / 100).toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }) + ' USD';
  }

  function findVariant(options) {
    var variantsData = window[key] ? window[key].variants : [];
    return variantsData.find(function (v) {
      return v.options.every(function (opt, i) {
        return opt === (options[i] || '');
      });
    });
  }


  function getSelectedOptions() {
    var opts = [];
    document.querySelectorAll('[data-option-index]').forEach(function (el) {
      var label = el.querySelector('[data-option-label]');
      if (label) opts.push(label.textContent.trim());
    });
    return opts;
  }

  function updateVariant(variant) {
    if (!variant) return;

    var idInput = document.getElementById('variant-id-' + sectionId);
    if (idInput) idInput.value = variant.id;

    var priceEls = document.querySelectorAll('[data-price="product-price-' + sectionId + '"]');
    priceEls.forEach(function (priceEl) {
      priceEl.textContent = formatMoney(variant.price);
    });

    var compareEls = document.querySelectorAll('[data-price="compare-price-' + sectionId + '"]');
    compareEls.forEach(function (compareEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        compareEl.textContent = formatMoney(variant.compare_at_price);
        compareEl.style.display = '';
      } else {
        compareEl.textContent = '';
        compareEl.style.display = 'none';
      }
    });

    //sku
    var skuEl = document.getElementById('product-sku-' + sectionId);
    if (skuEl) skuEl.textContent = variant.sku;

    var availEl = document.getElementById('ficha-availability-' + sectionId);
    if (availEl) {
      var availText   = availEl.dataset.available   || 'In stock';
      var unavailText = availEl.dataset.unavailable || 'Out of stock';

      if (variant.available) {
        availEl.querySelector('[data-availability-text]').textContent = availText;
        availEl.querySelector('[data-availability-wrap]').classList.remove('featured_label-oos');
        availEl.querySelector('[data-availability-wrap]').classList.add('featured_label-in-stock');
      } else {
        availEl.querySelector('[data-availability-text]').textContent = unavailText;
        availEl.querySelector('[data-availability-wrap]').classList.remove('featured_label-in-stock');
        availEl.querySelector('[data-availability-wrap]').classList.add('featured_label-oos');
      }
    }

    var buyNow  = document.querySelectorAll('[data-buy-now-' + sectionId + ']');
    var addCart = document.querySelectorAll('[data-add-cart-' + sectionId + ']');
    if (buyNow)  buyNow.forEach(function(btn) { btn.disabled = !variant.available; });
    if (addCart) addCart.forEach(function(btn) { btn.disabled = !variant.available; });

    if (variant.featured_image && variant.featured_image.src) {
      var mainImg = document.getElementById('ficha-main-image-' + sectionId);
      if (mainImg) {
        mainImg.src = variant.featured_image.src.replace(
          /(\.(jpg|jpeg|png|webp|gif))(\?.*)?$/i,
          '_1158x1158$1$3'
        );
      }
    }
  }

  document.querySelectorAll('[data-option-index]').forEach(function (container) {
    container.querySelectorAll('[data-option-value]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var label = container.querySelector('[data-option-label]');
        if (label) label.textContent = btn.dataset.optionValue;
        container.querySelectorAll('[data-option-value]').forEach(function (b) {
          b.classList.remove('active');
        });
        btn.classList.add('active');
        var details = container.querySelector('details');
        if (details) details.removeAttribute('open');

        var variant = findVariant(getSelectedOptions());
        updateVariant(variant);

        $(document).find('.w-dropdown').each(function (i, el) {
            $(el).triggerHandler('w-close.w-dropdown');
        });
      });
    });
  });

  function getRelatedProducts() {
    const relatedSections = document.querySelectorAll('product-recommendations');
    if (relatedSections.length === 0) return;

    relatedSections.forEach(function (section) {
      const data = section.dataset;
      var productId = data.productId;
      var url = data.url + '&section_id=' + data.sectionId + '&product_id=' + productId;
    
    fetch(url)
        .then(function (res) {
            if (!res.ok) throw new Error('HTTP ' + res.status);
            return res.text();
        })
        .then(function (html) {
            var parser = new DOMParser();
            var doc = parser.parseFromString(html, 'text/html');
            var newSection = doc.querySelector('product-recommendations');
            if (newSection) {
                section.innerHTML = newSection.innerHTML;
            }
        })
        .catch(function (err) {
            console.warn('[related-products] Error al cargar recomendaciones:', err);
        });
    });
  }

  function formatFileSize(bytes) {
    if (!bytes || bytes === 0) return 'Unknown size';
    var units = ['B', 'KB', 'MB', 'GB'];
    var i = Math.floor(Math.log(bytes) / Math.log(1024));
    return (bytes / Math.pow(1024, i)).toFixed(1) + ' ' + units[i];
  }

  function initDownloadFiles(){
    document.querySelectorAll('a[download]').forEach(function(link) {
      const url = link.getAttribute('href');
      let filename = url.split('/').pop().split('?')[0];
      filename = filename.replaceAll('_', ' ').split('.').slice(0, -1).join('.');

      fetch(url)
        .then(function(res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.blob();
        })
        .then(function(blob) {
          var fileSize = formatFileSize(blob.size);
          var fileType = blob.type ? blob.type.split('/')[1] : 'Unknown type';
          var fileInfoEl = link.querySelector('[data-file-info]');
          if (fileInfoEl) fileInfoEl.innerHTML = `(${fileType}, ${fileSize})`;
          var textPdfEl = link.querySelector('[data-file-name]');
          if (textPdfEl && textPdfEl.textContent == '') textPdfEl.innerHTML = `${filename}`;
          link.setAttribute('download', filename + '.' + fileType);
        })
        .catch(function(err) {
          console.warn('[initDownloadFiles] No se pudo obtener el tamaño de', filename, err);
        });
    });
  }

  function resizeProductLayout() {
      var width = $(window).width();
      const container = $("#shopify-section-" + sectionId);

      if (container.hasClass("mobile") && width < 768) return;
      if (container.hasClass("desktop") && width >= 768) return;

      const gallery = container.find("#galeria-" + sectionId);
      const info = container.find("[id$='product-info']");

      if (width < 768) {
          container.addClass("mobile").removeClass("desktop");
          if(info && gallery) {
            info.insertBefore(gallery);
          }
      } else {
          container.addClass("desktop").removeClass("mobile");
          const form = container.find("form");
          if(info && form) {
            info.insertBefore(form);
          }
      }
  }

  window.productEl = {
      init: function (secId, keyName) {
          
          if (!secId || !keyName) {
              return;
          }

          sectionId = secId;
          key = keyName;
          initGallery();
          getRelatedProducts();
          initDownloadFiles();
          resizeProductLayout();

          $("[data-empty-block]").each(function () {
              $(this).closest(".shopify-block").remove();
          });

          $(window).on('resize', resizeProductLayout)
      }
  };


})(window.jQuery);

$(".ficha_squared_description_small").click(function () {
    $(this).closest("[data-drop]").toggleClass("open");
});



